<template>
  <section class="section">
    <form>
      <div class="container">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title">
              {{ $translate('copy_order') | capitalize }}
            </h1>
          </div>
          <div class="column is-2 has-text-right">
            <button
              slot="trigger"
              type="button"
              class="button is-primary"
              :disabled="isSaveDisabled"
              @click="validateBeforeSubmit()"
            >
              <b-icon icon="content-save-outline" />
            </button>
          </div>
        </div>

        <b-field :label="$translate('primaryCode')" horizontal>
          <b-field :type="{ 'is-danger': errors.has('primaryCode') }" :message="errors.first('primaryCode')">
            <b-input v-model="ordertoarrive.primaryCode" v-validate="'required|unique'" name="primaryCode" />
          </b-field>
          <b-button type="button" class="button is-primary" icon-right="auto-fix" @click="primaryCodeCreation()">
            {{ $translate('generate_primaryCode') | capitalize }}
          </b-button>
        </b-field>

        <b-field
          :label="$translate('secondaryCode')"
          :type="{ 'is-danger': errors.has('secondaryCode') }"
          :message="errors.first('secondaryCode')"
          horizontal
        >
          <b-input v-model="ordertoarrive.secondaryCode" name="secondaryCode" />
        </b-field>
        <b-field
          :label="$translate('shoeType') | capitalize"
          :type="{ 'is-danger': errors.has('shoeType') }"
          :message="errors.first('shoeType')"
          horizontal
        >
          <b-select
            v-model="ordertoarrive.shoeType"
            v-validate="'required'"
            name="shoeType"
            :placeholder="$translate('placeholder_select')"
            :disabled="this.copyModel"
          >
            <option v-for="type in $availableShoeType" :key="type" :value="type">
              {{ $translate(type) | capitalize }}
            </option>
          </b-select>
        </b-field>
        <b-field :label="$translate('share_attach') | capitalize" horizontal>
          <b-switch v-model="copyAttachbool" />
        </b-field>
        <template v-if="bdictionary && bdictionary.length != 0">
          <b-field
            :label="$translate('orderType') | capitalize"
            :type="{ 'is-danger': errors.has('orderType') }"
            :message="errors.first('orderType')"
            horizontal
          >
            <b-select
              v-model="ordertoarrive.orderType"
              v-validate="'required'"
              name="orderType"
              :placeholder="$translate('placeholder_type')"
              @input="
                ordertoarrive.orderTypeMain = null
                ordertoarrive.orderTypeVariant = null
                ordertoarrive.orderTypeSubVariant = null
                $forceUpdate()
              "
            >
              <option v-for="optio in bdictionary" :key="optio.key" :value="optio.key">
                {{ $translate(optio.key) | capitalize }}
              </option>
            </b-select>
          </b-field>
        </template>
        <template
          v-if="
            bdictionary &&
              bdictionary.length != 0 &&
              bdictionary.find(temp => temp.key === ordertoarrive.orderType) != undefined &&
              bdictionary.find(temp => temp.key === ordertoarrive.orderType).variant
          "
        >
          <b-field
            v-if="bdictionary.find(temp => temp.key === ordertoarrive.orderType).variant"
            :label="$translate('orderTypeMain') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeMain') }"
            :message="errors.first('orderTypeMain')"
            horizontal
          >
            <b-select
              v-model="ordertoarrive.orderTypeMain"
              v-validate="'required'"
              name="orderTypeMain"
              :placeholder="$translate('placeholder_type')"
              @input="
                ordertoarrive.orderTypeVariant = null
                ordertoarrive.orderTypeSubVariant = null
                $forceUpdate()
              "
            >
              <option
                v-for="variant in bdictionary.find(temp => temp.key === ordertoarrive.orderType).variant"
                :key="variant.key"
                :value="variant.key"
              >
                {{ $translate(variant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>

        <template
          v-if="
            bdictionary &&
              bdictionary.length != 0 &&
              bdictionary.find(temp => temp.key === ordertoarrive.orderType) != undefined &&
              bdictionary.find(temp => temp.key === ordertoarrive.orderType).variant &&
              bdictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain) != undefined
          "
        >
          <b-field
            v-if="
              bdictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain).variant
            "
            :label="$translate('orderTypeVariant') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeVariant') }"
            :message="errors.first('orderTypeVariant')"
            horizontal
          >
            <b-select
              v-model="ordertoarrive.orderTypeVariant"
              v-validate="'required'"
              name="orderTypeVariant"
              :placeholder="$translate('placeholder_type')"
              @input="
                ordertoarrive.orderTypeSubVariant = null
                setSimplified()
                $forceUpdate()
              "
            >
              <option
                v-for="subvariant in bdictionary
                  .find(temp => temp.key === ordertoarrive.orderType)
                  .variant.find(temp => temp.key === ordertoarrive.orderTypeMain).variant"
                :key="subvariant.key"
                :value="subvariant.key"
              >
                {{ $translate(subvariant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>

        <template
          v-if="
            bdictionary &&
              bdictionary.length != 0 &&
              bdictionary.find(temp => temp.key === ordertoarrive.orderType) != undefined &&
              bdictionary.find(temp => temp.key === ordertoarrive.orderType).variant &&
              bdictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain) != undefined &&
              bdictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain).variant &&
              bdictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeVariant) != undefined
          "
        >
          <b-field
            v-if="
              bdictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeVariant).variant
            "
            :label="$translate('orderTypeSubVariant') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeSubVariant') }"
            :message="errors.first('orderTypeSubVariant')"
            horizontal
          >
            <b-select
              v-model="ordertoarrive.orderTypeSubVariant"
              v-validate="'required'"
              name="orderTypeSubVariant"
              :placeholder="$translate('placeholder_type')"
            >
              <option
                v-for="subsubvariant in bdictionary
                  .find(temp => temp.key === ordertoarrive.orderType)
                  .variant.find(temp => temp.key === ordertoarrive.orderTypeMain)
                  .variant.find(temp => temp.key === ordertoarrive.orderTypeVariant).variant"
                :key="subsubvariant.key"
                :value="subsubvariant.key"
              >
                {{ $translate(subsubvariant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>

        <b-field
          v-if="
            ordertoarrive.orderTypeVariant == 'card2' ||
              (ordertoarrive.orderTypeVariant && ordertoarrive.orderTypeMain == 'last') ||
              (ordertoarrive.orderTypeVariant && ordertoarrive.orderTypeMain == 'mold')
          "
          :label="$translate('formcode') | capitalize"
          :type="{ 'is-danger': errors.has('formcode') }"
          :message="errors.first('formcode')"
          horizontal
        >
          <b-input v-model="ordertoarrive.formcode" name="formcode" />
        </b-field>

        <template v-if="ddictionary && ddictionary.length != 0">
          <b-field
            :label="$translate('deliverySelected') | capitalize"
            :type="{ 'is-danger': errors.has('deliverySelected') }"
            :message="errors.first('deliverySelected')"
            horizontal
          >
            <b-select
              v-model="ordertoarrive.deliverySelected"
              v-validate="'required'"
              name="deliverySelected"
              :placeholder="$translate('placeholder_type')"
              @input="
                ordertoarrive.deliverySelectedSub = null
                $forceUpdate()
              "
            >
              <option v-for="optio in this.ddictionary" :key="optio.key" :value="optio.key">
                {{ $translate(optio.key) }}
              </option>
            </b-select>
          </b-field>
        </template>
        <template
          v-if="
            ddictionary &&
              ddictionary.length != 0 &&
              ddictionary.find(temp => temp.key === ordertoarrive.deliverySelected) != undefined
          "
        >
          <b-field
            v-if="ddictionary.find(temp => temp.key === ordertoarrive.deliverySelected).variant"
            :label="$translate('deliverySelectedSub') | capitalize"
            :type="{ 'is-danger': errors.has('deliverySelectedSub') }"
            :message="errors.first('deliverySelectedSub')"
            horizontal
          >
            <b-select
              v-model="ordertoarrive.deliverySelectedSub"
              v-validate="'required'"
              name="deliverySelectedSub"
              :placeholder="$translate('placeholder_type')"
            >
              <option
                v-for="variant in ddictionary.find(temp => temp.key === ordertoarrive.deliverySelected).variant"
                :key="variant.key"
                :value="variant.key"
              >
                {{ $translate(variant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>
        <b-field :label="$translate('copy_claim') | capitalize" horizontal>
          <b-switch v-model="copyClaimbool" />
        </b-field>

        <b-field :label="$translate('copy_model') | capitalize" horizontal>
          <b-switch v-model="copyModel" @input="copyModelCheck" />
        </b-field>
      </div>
    </form>
    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import orderTools from '@/helpers/mixins/orderTools'
import firebase from 'firebase'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'
import modelClass from '@/helpers/mixins/modelTools'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'CopyOrder',
  mixins: [orderTools, keyWordGenerator],
  props: ['orderIdToCopy'],
  data() {
    return {
      isSaveDisabled: false,
      copyAttachbool: false,
      copyClaimbool: false,
      copyModel: false,
      ddictionary: null,
      bdictionary: null,
      patient: {},
      order: {},
      ordertoarrive: {},
      duplicatedOrder: {},
    }
  },
  created() {
    this.$validator.extend('unique', async value => {
      var temparray = []
      await this.$db
        .collection('orders')
        .where('primaryCode', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id != this.id) {
              temparray.push(doc.data().primaryCode)
            }
          })
        })

      if (temparray.includes(value)) {
        return false
      }
      return true
    })
  },
  async mounted() {
    //console.log("semplificato")
    this.isSaveDisabled = true
    const doc = await this.$db
      .collection('orders')
      .doc(this.orderIdToCopy)
      .get()
    this.order = doc.data()
    let actualClaim = []
    if (Array.isArray(this.order.claims)) {
      for (let claim of this.order.claims || []) {
        if (claim.AdminClaim) {
          claim.id = actualClaim.length
          actualClaim.push(claim)
        }
      }
    }
    this.order.claims = actualClaim

    //const {
    //shoeType,
    //deliverySelected,
    //orderTypeMain,
    //primaryCode,
    //attachment,
    //attachmentflag,
    //secondaryCode,
    //tec,
    //send_date,
    //id_mercury,
    //materialprod,
    //materialacc,
    //...duplicatedOrder
    //} = doc.data()
    //console.log(duplicatedOrder)
    this.ordertoarrive = doc.data()
    this.ordertoarrive.module = this.ordertoarrive.module || 'tailored'
    this.ordertoarrive.shoeType = null
    this.ordertoarrive.deliverySelected = null
    this.ordertoarrive.orderType = 'firstOrder'
    this.ordertoarrive.orderTypeMain = null

    this.ordertoarrive.primaryCode = null
    this.ordertoarrive.attachment = {}
    this.ordertoarrive.attachmentflag = {}
    this.ordertoarrive.secondaryCode = null
    this.ordertoarrive.tec = null
    this.ordertoarrive.send_date = null
    this.ordertoarrive.id_mercury = null

    this.ordertoarrive.materialprod = []
    this.ordertoarrive.materialacc = []
    await this.loadPatientStatfromOrder()
    this.isSaveDisabled = false
  },
  methods: {
    setSimplified() {
      const newOrder = this.ordertoarrive
      //console.log(newOrder.orderType)
      //console.log(newOrder.orderTypeMain)
      if (newOrder.orderType == 'relatedOrder' && newOrder.orderTypeMain == 'ToModifyafter') {
        this.setDefault()
      }
    },
    setDefault() {
      this.isSaveDisabled = true
      this.ordertoarrive.primaryCode = `${this.order.primaryCode}-F`
      this.ordertoarrive.secondaryCode = this.order.secondaryCode ? `${this.order.secondaryCode}-F` : null

      this.ordertoarrive.deliverySelected = 'devshoeended'
      this.ordertoarrive.deliverySelectedSub = 'devshoeended'

      this.copyModel = true
      this.copyModelCheck()

      this.isSaveDisabled = false
    },
    copyModelCheck() {
      if (this.copyModelCheck) {
        this.ordertoarrive.shoeType = this.order.shoeType
        this.copyClaimbool = true
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('start_copy'),
            queue: false,
          })

          this.send()
          return
        } else {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        }
      })
    },
    async send() {
      this.isSaveDisabled = true
      this.ordertoarrive.statusOrder = 'draft'
      let realprimaryCode = this.ordertoarrive.primaryCode
      this.ordertoarrive.creationDate = new Date().getTime()
      this.ordertoarrive.searchArray = this.generateKeyWord([
        this.ordertoarrive.patient.name,
        this.ordertoarrive.patient.surname,
        this.ordertoarrive.patient.name + ' ' + this.ordertoarrive.patient.surname,
        this.ordertoarrive.primaryCode,
        this.ordertoarrive.id_mercury,
        this.ordertoarrive.company.name,
        this.ordertoarrive.shop.name,
        this.ordertoarrive.tec,
      ])

      await this.$db
        .collection('orders')
        .add(this.ordertoarrive)
        .then(docRef => {
          this.ordertoarrive.id = docRef.id
        })

      this.ordertoarrive.primaryCode = realprimaryCode
      //console.log(this.ordertoarrive.id);
      this.ordertoarrive.statusOrder = 'compord'
      if (this.copyAttachbool) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('start_copy_attach'),
          queue: false,
        })

        await this.copyAttach()
      }
      if (!this.copyClaimbool) {
        this.ordertoarrive.claims = {}
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('start_copy_claim'),
          queue: false,
        })
        await this.copyAttachClaims()
      }
      if (!this.copyModel) {
        this.ordertoarrive.mod = new modelClass()
        this.ordertoarrive.mod = this.ordertoarrive.mod.returnObject()
        this.ordertoarrive.mod.catalogchoose = true
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('copy_model'),
          queue: false,
        })
      }

      this.ordertoarrive.lastModificationDate = new Date().getTime()
      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.ordertoarrive.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.ordertoarrive.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.ordertoarrive.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.ordertoarrive.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.ordertoarrive.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.ordertoarrive.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.ordertoarrive.id)
      batch.update(orderupdate, this.ordertoarrive)
      batch
        .commit()
        .then(() => {
          this.isSaveDisabled = false
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
            queue: false,
          })
          this.$router.push({
            name: 'editOrder',
            params: { orderId: this.ordertoarrive.id, view: true, module: this.ordertoarrive.module },
          })
        })
        .catch(() => {
          //console.log(err);
          this.isSaveDisabled = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
      this.isSaveDisabled = false
    },
    async copyAttachClaims() {
      for (let index in this.order.claims) {
        if (this.order.claims[index].attachbool) {
          await this.moveFirebaseClaimFile(
            'order/attachment/' + this.orderIdToCopy + '/claim/' + index,
            'order/attachment/' + this.ordertoarrive.id + '/claim/' + index,
            index
          )
        }
        if (this.order.claims[index].attachboolanswer) {
          await this.moveFirebaseClaimFile(
            'order/attachment/' + this.orderIdToCopy + '/claimanswer/' + index,
            'order/attachment/' + this.ordertoarrive.id + '/claimanswer/' + index,
            index
          )
        }
      }
    },
    async copyAttach() {
      if (this.order.attachment && Object.keys(this.order.attachment).length > 0) {
        for (let index in this.order.attachment) {
          if (this.order.attachment[index] != null) {
            await this.moveFirebaseAttachFile(
              'order/attachment/' + this.orderIdToCopy + '/' + index,
              'order/attachment/' + this.ordertoarrive.id + '/' + index,
              index
            )
          }
        }
      }
    },
    async primaryCodeCreation() {
      this.isSaveDisabled = true
      let mercurio_id = '-'
      await this.$db
        .collection('companies')
        .doc(this.order.companyId)
        .get()
        .then(async com => {
          mercurio_id = com.data().mercurio_id
          if (com.data().orders) {
            this.patient.progressivenumber = com.data().orders.length + 1
          } else {
            this.patient.progressivenumber = 1
          }
        })

      let today = new Date()
      let day = String(today.getUTCDate()).padStart(2, '0')
      let month = String(today.getUTCMonth() + 1).padStart(2, '0')

      this.ordertoarrive.primaryCode =
        day +
        month +
        today.getUTCFullYear() +
        '-' +
        mercurio_id +
        '-' +
        ('0000' + this.patient.progressivenumber).substr(-4, 4)

      this.isSaveDisabled = false
      this.$forceUpdate()
    },
    async moveFirebaseClaimFileAnswer(currentPath, destinationPath, index) {
      const cloneDeep = require('clone-deep')
      let oldRef = this.$storage.ref().child(currentPath)
      let oldmetadata = {}
      await oldRef.getMetadata().then(metadata => {
        oldmetadata.contentType = metadata.contentType
      })
      //console.log(oldmetadata);

      await oldRef
        .getDownloadURL()
        .then(async url => {
          await fetch(url).then(async htmlReturn => {
            let previousChunk = new Uint8Array()
            let fileArray = new Uint8Array()
            const reader = htmlReturn.body.getReader()
            await reader
              .read()
              .then(function appendStreamChunk({ done, value }) {
                if (value) {
                  previousChunk = cloneDeep(fileArray)
                  fileArray = new Uint8Array(previousChunk.length + value.length)
                  fileArray.set(previousChunk)
                  fileArray.set(value, previousChunk.length)
                }
                if (done) {
                  return fileArray
                } else {
                  return reader.read().then(appendStreamChunk)
                }
              })
              .then(async file => {
                await this.$storage
                  .ref()
                  .child(destinationPath)
                  .put(file, oldmetadata)
                  .then(async snapshot => {
                    //console.log(oldmetadata);

                    await snapshot.ref.getDownloadURL().then(url => {
                      this.ordertoarrive.claims[index].attachanswer = url
                      this.ordertoarrive.claims[index].attachboolanswer = true
                    })
                  })
              })
              .catch(() => {})
          })
        })
        .catch(() => {})
    },

    async moveFirebaseClaimFile(currentPath, destinationPath, index) {
      const cloneDeep = require('clone-deep')
      let oldRef = this.$storage.ref().child(currentPath)
      let oldmetadata = {}
      await oldRef.getMetadata().then(metadata => {
        oldmetadata.contentType = metadata.contentType
      })
      //console.log(oldmetadata);

      await oldRef
        .getDownloadURL()
        .then(async url => {
          await fetch(url).then(async htmlReturn => {
            let previousChunk = new Uint8Array()
            let fileArray = new Uint8Array()
            const reader = htmlReturn.body.getReader()
            await reader
              .read()
              .then(function appendStreamChunk({ done, value }) {
                if (value) {
                  previousChunk = cloneDeep(fileArray)
                  fileArray = new Uint8Array(previousChunk.length + value.length)
                  fileArray.set(previousChunk)
                  fileArray.set(value, previousChunk.length)
                }
                if (done) {
                  return fileArray
                } else {
                  return reader.read().then(appendStreamChunk)
                }
              })
              .then(async file => {
                await this.$storage
                  .ref()
                  .child(destinationPath)
                  .put(file, oldmetadata)
                  .then(async snapshot => {
                    //console.log(oldmetadata);

                    await snapshot.ref.getDownloadURL().then(url => {
                      //console.log(index);
                      this.ordertoarrive.claims[index].attach = url
                      this.ordertoarrive.claims[index].attachbool = true
                    })
                  })
              })
              .catch(() => {})
          })
        })
        .catch(() => {})
    },
    async moveFirebaseAttachFile(currentPath, destinationPath, index) {
      const cloneDeep = require('clone-deep')
      let oldRef = this.$storage.ref().child(currentPath)
      let oldmetadata = {}
      await oldRef.getMetadata().then(metadata => {
        oldmetadata.contentType = metadata.contentType
      })
      //console.log(oldmetadata);

      await oldRef
        .getDownloadURL()
        .then(async url => {
          await fetch(url).then(async htmlReturn => {
            let previousChunk = new Uint8Array()
            let fileArray = new Uint8Array()
            const reader = htmlReturn.body.getReader()
            await reader
              .read()
              .then(function appendStreamChunk({ done, value }) {
                if (value) {
                  previousChunk = cloneDeep(fileArray)
                  fileArray = new Uint8Array(previousChunk.length + value.length)
                  fileArray.set(previousChunk)
                  fileArray.set(value, previousChunk.length)
                }
                if (done) {
                  return fileArray
                } else {
                  return reader.read().then(appendStreamChunk)
                }
              })
              .then(async file => {
                await this.$storage
                  .ref()
                  .child(destinationPath)
                  .put(file, oldmetadata)
                  .then(async snapshot => {
                    //console.log(oldmetadata);

                    await snapshot.ref.getDownloadURL().then(url => {
                      //console.log(index);
                      this.ordertoarrive.attachment[index] = url
                      this.ordertoarrive.attachmentflag[index] = 1
                    })
                  })
              })
              .catch(() => {})
          })
        })
        .catch(() => {})
    },
  },
}
</script>
